const {SESSION_PROJECT_USERS_CHANGED} = require("../../gd/bus/bus-event-type")

var Event = function(uid,data) {
    this.data = data;
    this.uid = uid;
};

Event.prototype.validate = function(){
    return true;
};

Event.prototype.process = function(){
    gd.session.projectUsers.resetAndKeepOldModels(this.data)
    gd.bus.triggerEvent(SESSION_PROJECT_USERS_CHANGED)
};

module.exports = Event;
